import React from "react";
import { HeartHandshake, Activity, Clock, ShieldCheck, ArrowLeft } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const servicesData = [{
  id: "live-in",
  title: "מטפל סיעודי צמוד 24/7",
  description: "שירותי סיעוד והשגחה מלאים בבית המטופל, המעניקים שקט נפשי למשפחה וטיפול מסור מסביב לשעון.",
  icon: HeartHandshake,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_live_in_care.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_live_in_care.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_live_in_care.png-wvc-sizes",
    alt: "מטפל סיעודי צמוד"
  },
  badge: "פופולרי"
}, {
  id: "hospital",
  title: "השגחה בבתי חולים",
  description: "ליווי והשגחה אישית במהלך אשפוז, סיוע בהאכלה, ניידות ושמירה על כבודו ובטיחותו של המטופל.",
  icon: Activity,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_hospital_care.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_hospital_care.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_hospital_care.png-wvc-sizes",
    alt: "השגחה בבתי חולים"
  }
}, {
  id: "short-term",
  title: "טיפול קצר מועד",
  description: "פתרונות סיעוד גמישים למספר שעות ביום או לתקופות קצרות, מותאמים אישית לצרכים המשתנים.",
  icon: Clock,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_short_term.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_short_term.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_short_term.png-wvc-sizes",
    alt: "טיפול קצר מועד"
  }
}, {
  id: "consultation",
  title: "ייעוץ והכוונה מקצועית",
  description: "ליווי משפחות בתהליך קבלת ההחלטות, סיוע במיצוי זכויות מול הרשויות והתאמת תוכנית טיפול.",
  icon: ShieldCheck,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_consultation.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_consultation.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/service_consultation.png-wvc-sizes",
    alt: "ייעוץ והכוונה מקצועית"
  }
}];
export default function NursingServices() {
  return <section id="שירותים-סיעודיים" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-12 md:mb-16">
          <Badge variant="secondary" className="mb-4">
            השירותים שלנו
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tight mb-4 text-primary">
            פתרונות סיעוד מותאמים אישית
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl font-sans">
            אנו מציעים מגוון רחב של שירותי סיעוד מקצועיים, הניתנים על ידי צוות מיומן ומסור, במטרה להעניק את הטיפול הטוב ביותר ליקיריכם.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-12">
          {servicesData.map((service, index) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={index} className="overflow-hidden flex flex-col h-full border-border/50 shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="relative h-48 w-full overflow-hidden bg-muted">
                  <img src={service.image.src} data-wvc-srcset={service.image.srcset} data-wvc-sizes={service.image.sizes} alt={service.image.alt} className="object-cover w-full h-full transition-transform duration-500 hover:scale-105" loading="lazy" />
                  {service.badge && <Badge className="absolute top-4 right-4 bg-primary text-primary-foreground shadow-sm">
                      {service.badge}
                    </Badge>}
                </div>
                <CardHeader className="pb-4">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="p-2 rounded-lg bg-primary/10 text-primary">
                      <Icon className="w-5 h-5" />
                    </div>
                    <CardTitle className="text-xl font-default text-foreground">
                      {service.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription className="text-base font-sans text-muted-foreground leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <Button asChild size="lg" className="w-full sm:w-auto text-base font-medium">
            <Link to="/NursingCareNowPage">
              הזמן מטפל עכשיו
              <ArrowLeft className="mr-2 w-5 h-5" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base font-medium">
            <Link to="/ContactPage">
              לקבלת ייעוץ חינם
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}